import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader'; 
import { usePesquisaADM } from '../../hooks/usePesquisaADM';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const Treinamento = () => {

  const {
    handleSearch,
    handleSelectUnidadeTreinamento,
    valueUnidade,
    setValueUnidade,
    isLoading,
    resultados,
    navigate
  } = usePesquisaADM();

  return (
    <div>
      <section>
      <h3>Digite a unidade que deseja solicitar o treinamento:</h3>
      <form onSubmit={handleSearch}>
        <div className='pesquisa'>
        <input className='pesquisar'
            type="text" 
            placeholder="Pesquisa Geral" 
            value={valueUnidade}
            onChange={(e) => setValueUnidade(e.target.value)} 
        />
        </div>
        <button type="submit" disabled={isLoading}className='botaopesquisa'>
          {isLoading ? <ClipLoader size={15} /> : 'Procurar'}
        </button>
      </form>

      {resultados.length > 0 && (
        <div>
          <h2 className='unidades'>Unidades:</h2>
          {resultados.map((unidade) => (
            <button className='unidade' key={unidade.Id} onClick={() => handleSelectUnidadeTreinamento(unidade.Id)}>
              {unidade.Nome}
            </button>
          ))}
        </div>
      )}
      <button onClick={() => navigate('/options')}className='botaovoltar'>
      <FontAwesomeIcon icon={faArrowLeft} className='arrow-left-icon' />
      <span>Voltar</span>
      </button>
      </section>
    </div>
  );
};

export default Treinamento;
